import React, { useEffect } from 'react';
import { X } from 'lucide-react';

/**
 * Scrollable modal shell — same pattern as SO create / Milestones (bt-modal-*).
 * Header + close stay visible; body scrolls inside max viewport height.
 */
export function AppModal({
  title,
  subtitle,
  onClose,
  children,
  footer,
  maxWidth = 560,
  className = '',
}) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div
      className="bt-modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      role="presentation"
    >
      <div
        className={`bt-modal w-full ${className}`}
        style={{ maxWidth }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="app-modal-title"
      >
        <div className="bt-modal-header">
          <div className="min-w-0 pr-3">
            <h3 id="app-modal-title" className="bt-modal-title">{title}</h3>
            {subtitle && (
              <p className="text-sm mt-0.5 truncate" style={{ color: 'var(--bt-gray-500)' }}>{subtitle}</p>
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="bt-modal-close"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>
        <div className="bt-modal-body">{children}</div>
        {footer != null && <div className="bt-modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

export function ConfirmModal({
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onClose,
  loading = false,
  danger = false,
}) {
  return (
    <AppModal
      title={title}
      onClose={onClose}
      maxWidth={480}
      footer={(
        <>
          <button type="button" onClick={onClose} className="btn-secondary" disabled={loading}>
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={danger ? 'btn-danger' : 'btn-primary'}
            disabled={loading}
          >
            {loading ? 'Please wait…' : confirmLabel}
          </button>
        </>
      )}
    >
      <p className="text-sm text-gray-600 whitespace-pre-line leading-relaxed">{message}</p>
    </AppModal>
  );
}
